import { useOutletContext } from 'react-router-dom'

import ErrorBoundary from 'modules/core/components/ErrorBoundary'

import { RouteContextParams } from 'modules/employees/lib/RouteContextParams'
import CollectionsBootstrap from 'modules/profile/lib/EmployeesCollectionsBootstrap'
import ProfileOverviewPage from 'modules/profile/pages/ProfileOverviewPage'
import ProfilePage from 'modules/profile/pages/ProfilePage'

const Container = () => {
  const context = useOutletContext<RouteContextParams>()

  if (context.canSeeOverview) {
    return (
      <ErrorBoundary>
        <ProfileOverviewPage />
      </ErrorBoundary>
    )
  }

  return <ProfilePage />
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
